import { useState } from "react";
import { Box, Button, Group, Stack, Flex, Text } from "@mantine/core";
import AddressInput from "./AddressInput";
import DateTimeInput from "./DateTimeInput";

export default function StopSelector({
  type,
  locations,
  location,
  index,
  updateLocation,
  isRequired,
  isRoundTrip,
  tripType,
  removeCurrentStop,
  useDiy,
}) {
  const [isInvalid, setIsInvalid] = useState(false);
  const isShuttle = tripType === "shuttle";
  const showRemove = tripType === "custom" && type === "stop";
  const showDateTimeAsDestintation =
    type !== "destination" ||
    (type === "destination" && (isRoundTrip || isShuttle));

  let headingText = "";
  switch (type) {
    case "departure":
      headingText = "Starting from";
      break;

    case "stop":
      headingText = isRoundTrip ? "Destination" : "Stop at";
      break;

    case "destination":
      if (isRoundTrip) {
        headingText = "Destination";
      } else {
        headingText = "Ending at";
      }
      break;

    default:
      console.log("No match");
  }

  const boxHeight = () => {
    if (type === "destination") {
      if (isShuttle) return 200;
      if (!isRoundTrip) return 80;
    }
    return 200;
  };

  return (
    <Box h={boxHeight}>
      <Flex justify="space-between">
        <Group justify="space-between" w="100%">
          <Text size="sm" fw={700} c={isInvalid ? "red" : ""}>
            {headingText}{" "}
            {isRequired && <span style={{ color: "red" }}>*</span>}
          </Text>
          {showRemove && (
            <Button
              variant="transparent"
              c="red"
              size="compact-xs"
              onClick={() => removeCurrentStop(index)}
            >
              Remove Stop
            </Button>
          )}
        </Group>
      </Flex>
      {isInvalid && (
        <Text size="xs" mb={10} c="red">
          Must be later than previous stop
        </Text>
      )}
      <Stack gap="md">
        <AddressInput
          key={location.id}
          location={location}
          index={index}
          updateLocation={updateLocation}
          locationType={type}
        />
        {showDateTimeAsDestintation && (
          <DateTimeInput
            locations={locations}
            location={location}
            index={index}
            updateLocation={updateLocation}
            setIsInvalid={setIsInvalid}
            isInvalid={isInvalid}
            showDateTimeAsDestintation={showDateTimeAsDestintation}
            isRoundTrip={isRoundTrip}
            useDiy={useDiy}
          />
        )}
      </Stack>
    </Box>
  );
}
